import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Logger } from 'src/app/api/helper/app-error-logger';
import { AuftragsKomponente, Workflow } from 'src/app/api/model/swagger-model';
import { StammdatenService } from 'src/app/api/stammdaten.service';
import { Auftragdetails } from '../auftragdetails.helper';
import { KomponenteBase } from './komponente';

const log = new Logger("AuftragLieferungDetailsComponent");

@Component({
    selector: 'auftrag-lieferung-details-komponente',
    template: `
        <div class="auftrag-lieferung-details-komponente">
          <div>
            <h1 *ngIf="titel">{{ titel | translate }}</h1>
            <app-auftrag-lieferung-details
                       [auftrag]="auftrag"
                       [auftragdetails]="auftragdetails"
                       [artikelHinzufuegenButtonAnzeigen]="artikelHinzufuegenButtonAnzeigen"
                       [plusMinusButtonAnzeigen]="plusMinusButtonAnzeigen"
                       #auftragLieferung></app-auftrag-lieferung-details>
          </div>
        </div>
    `,
    styles: [`
    h1 {
        padding-left: 20px;
    }
    `],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AuftragLieferungDetailsComponent extends KomponenteBase implements OnInit {

    @Input() auftragdetails: Auftragdetails;
    @Input() komponente: AuftragsKomponente;

    titel = '';

    plusMinusButtonAnzeigen = true;
    artikelHinzufuegenButtonAnzeigen = true;

    constructor(
        private router: Router,
        protected cdr: ChangeDetectorRef) {
        super(cdr);
    }

    ngOnInit() {
        super.ngOnInit();

        this.plusMinusButtonAnzeigen = this.auftragdetails.getEinstellung(this.komponente, 'PlusMinusButtons', 'ja') === 'ja';
        this.artikelHinzufuegenButtonAnzeigen =  this.auftragdetails.getEinstellung(this.komponente, 'ArtikelHinzufuegenButtonAnzeigen', 'ja') === 'ja';

        this.updateUi();
    }

    onWorkflowChanged() {
        this.updateUi();
    }

    updateUi() {
        this.titel = this.getEinstellung('Titel');
    }
}
